// Generated by ReScript, PLEASE EDIT WITH CARE

import * as DateTime$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/DateTime.bs.js";

function getVM(data) {
  return {
          ownerName: data.ownerName,
          regdAddress: data.regdAddress,
          financialYear: DateTime$Catalyst.toString("YYYY", data.financialYearStartDate) + ("-" + DateTime$Catalyst.toString("YY", data.financialYearEndDate)),
          financialYearStartDate: DateTime$Catalyst.toString("DD-MM-YYYY", data.financialYearStartDate),
          financialYearEndDate: DateTime$Catalyst.toString("DD-MM-YYYY", data.financialYearEndDate),
          ownerPan: data.ownerPan,
          place: data.place,
          pdfLink: data.pdfLink,
          status: data.status
        };
}

export {
  getVM ,
  
}
/* DateTime-Catalyst Not a pure module */
